import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/my_company_members/DetailsForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { __, mapStateToProps, transformToListPairs } from '../../core/utils';
import { map } from 'lodash';
import Input from '../../components/Input';
import Select from '../../components/Select';
import people_addressing from '../../lists/people_addressing';
import { listPossibleTags } from '../../redux/actions/general';
import * as _ from 'lodash';
import MultiSelect from '../../components/MultiSelect';

@reduxForm({
  form: 'my_company_members.details',
  enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  user_id: state.auth.id,
  company_id: state.auth.company.id,
}))
@subscribe(Localization, 'localization')
class DetailsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_countries: [],
      possible_education_school_tags: [],
    };
  }

  componentDidMount() {
    listPossibleTags('hr', this.props.company_id).then(({ response }) => {
      this.setState({ possible_education_school_tags: response.data });
    });
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    const { localization } = this.props;

    const { possible_education_school_tags } = this.state;

    const available_disciplines = _.sortBy(
      localization.disciplines,
      'priority'
    );

    // const project_languages = data.project.languages;

    // const { project_languages, status } = data;

    const country_options = map(localization.countries, (country) => {
      return {
        value: country.id,
        label: country.name,
      };
    });

    const disabled = false;

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='employee_id'
                component={Input}
                label={__('my_company_members.flyout.employee_id')}
              />
            </div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='title'
                component={Select}
                searchable={true}
                label={__('my_company_members.flyout.prefix')}
                options={people_addressing}
              />
            </div>
            <div className={styles.f1} />
            <div className={styles.f1} />
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='work_vpn'
                component={Input}
                label={__('my_company_members.flyout.work_vpn')}
              />
            </div>
            <div className={styles.f1} />
            <div className={styles.f1} />
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='firstname'
                component={Input}
                label={__('my_company_members.flyout.name')}
                inputTooltip={__(
                  'my_company_members.flyout.change-name-go-to-profile-settings'
                )}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='middlename'
                component={Input}
                label={__('my_company_members.flyout.middle_name')}
                inputTooltip={__(
                  'my_company_members.flyout.change-middle-name-go-to-profile-settings'
                )}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='lastname'
                component={Input}
                label={__('my_company_members.flyout.surname')}
                inputTooltip={__(
                  'my_company_members.flyout.change-last-name-go-to-profile-settings'
                )}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='disciplines'
                noSort
                component={MultiSelect}
                searchable
                label={__('my_company_members.flyout.profession')}
                inputTooltip={__(
                  'my_company_members.flyout.change-profession-go-to-profile-settings'
                )}
                options={transformToListPairs(
                  available_disciplines,
                  'profession'
                )}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='phone_number'
                component={Input}
                label={__('my_company_members.flyout.work_phone_number')}
                inputTooltip={__(
                  'my_company_members.flyout.change-phone-number-go-to-profile-settings'
                )}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={true}
                name='email'
                component={Input}
                label={__('my_company_members.flyout.work_email')}
                inputTooltip={__(
                  'my_company_members.flyout.change-email-go-to-profile-settings'
                )}
              />
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default DetailsForm;
